import Cookies from 'js-cookie';

class Bulletpoints {
	init() {
		// Check if the premium bulletpoints are enabled
		if (!window.bi_piano?.premium_features?.bulletpoints) {
			return;
		}

		const cookie = Cookies.get('bi_ad_type');
		if (typeof cookie === 'undefined') {
			return;
		}

		// Check if the user has the no_content_ads or no_ads cookie, this means it is a premium user
		if (!(cookie === 'no_content_ads' || cookie === 'no_ads')) {
			return;
		}

		// Get the premium bulletpoints and remove the teaser text
		document.querySelector('.bi-bulletpoints__teaser-text')?.remove();
		document
			.querySelector('.bi-bulletpoints__text--hidden')
			?.classList.remove('bi-bulletpoints__text--hidden');
	}
}

const instance = new Bulletpoints();
export default instance;
